(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
